import { deriveBooleanValue } from '~libs/records';

import { faEdit } from '~components/icon';
import { Column, Row } from '~components/table-view-v3';
import { linkCellRender } from '~components/table-view-v3/columnRenderers';

// v3 Column plus the API request metadata the OLD config carried
type UserColumn = Column & {
  // Association to request for nested values (e.g. level.name)
  association?: string;
  // Attribute to request when it differs from `id` (e.g., id: "gender.name", attribute: "gender")
  attribute?: string;
};

const columnsList: UserColumn[] = [
  {
    id: 'full_name',
    header: 'Full Name',
    type: 'text',
  },
  {
    id: 'date_last_login',
    header: 'Last Login',
    type: 'date',
  },
  {
    id: 'level.name',
    header: 'User Level',
    type: 'text',
    association: 'level',
    deriveValue: (row) => row.level?.name ?? '',
  },
  {
    id: 'department.name',
    header: 'Team',
    type: 'text',
    association: 'department',
    deriveValue: (row) => row.department?.name ?? '',
  },
  {
    id: 'suburb',
    header: 'Suburb',
    type: 'text',
  },
  {
    id: 'postcode',
    header: 'Postcode',
    type: 'text',
  },
  {
    id: 'gender.name',
    attribute: 'gender',
    header: 'Gender',
    type: 'text',
    deriveValue: (row) => row.gender?.name ?? '',
  },
  {
    id: 'accounts_access_enabled',
    header: 'Accounts Access Enabled',
    type: 'text',
    deriveValue: (row) => deriveBooleanValue(row.accounts_access_enabled as boolean),
  },
  {
    id: 'unlocking_permissions',
    header: 'Unlocking Allowed',
    type: 'text',
    deriveValue: (row) => deriveBooleanValue(row.unlocking_permissions as boolean),
  },
];

const displayList = (onOpen: (row: Row) => void): Column[] =>
  columnsList.map((column) =>
    column.id === 'full_name' ? { ...column, renderReadOnly: linkCellRender(onOpen, faEdit) } : column,
  );

export default {
  attributes: Array.from(new Set(['id', ...columnsList.map(({ id, attribute }) => attribute ?? id)])),
  associations: columnsList.map(({ association }) => association).filter((a): a is string => Boolean(a)),
  displayList,
};
